<template>
  <div id="userChgCard">
    <em
      ><span
        >尊敬的客户，您的换卡申请预计在1个工作日内处理完毕，请耐心等待。</span
      ></em
    >

    <van-cell-group class="form-input">
      <van-field v-model="recordLoginText" required label="卡号：" readonly />

      <van-field
        v-model="userInfo.takeNickname"
        required
        clearable
        label="收件人姓名："
        placeholder="请输入您的姓名"
        :disabled="disabledFlag"
      />

      <van-field
        v-model="userInfo.takePhone"
        required
        clearable
        label="手机号码："
        placeholder="请输入您的手机号码"
        :disabled="disabledFlag"
      />

      <van-field
        v-model="userInfo.pcaAddress"
        required
        clearable
        label="地区："
        placeholder="请选择地区"
        readonly
        @click="showAddressVisible()"
      />

      <van-field
        v-model="userInfo.takeAddress"
        required
        clearable
        label="详细地址："
        placeholder="请输入您的详细地址"
        :disabled="disabledFlag"
      />

      <!-- <van-field
        v-model="userInfo.changeCmccSimName"
        required
        clearable
        label="卡类型："
        placeholder="请选择卡类型"
        readonly
        @click="showPopupVisible()"
      />

     
-->
    <p class="tip" v-if="userInfo.disposeState != 2">{{ tips }}</p>
      <van-field
        v-model="userInfo.equipment"
        required
        clearable
        :disabled="disabledFlag"
        label="备注："
        placeholder="请输入您的备注"
      /> 

      <van-field
        v-if="userInfo.disposeState == 2 || userInfo.disposeState == 3"
        v-model="userInfo.disposeRemark"
        readonly
        :disabled="disabledFlag"
        :label="userInfo.disposeState == 2 ? '处理结果：' : '快递单号：'"
      />
    </van-cell-group>

    <!--  地区选择  -->
    <van-popup v-model="addressVisible" position="bottom">
      <van-area
        :area-list="areaList"
        :columns-placeholder="['请选择', '请选择', '请选择']"
        @cancel="cancelSelectAddress()"
        @confirm="selectAddress"
      />
    </van-popup>

    <!-- 卡类型选择 -->
    <van-popup v-model="popupVisible" position="bottom">
      <van-picker
        show-toolbar
        :columns="slots"
        :default-index="defaultIndex"
        @cancel="popupVisible = !popupVisible"
        @confirm="selectValue"
      />
    </van-popup>

    <div class="btnOuter">
      <!-- <p class="tip" v-if="isNeedPostage">
        亲，我司提供免费换卡，但为避免资源浪费，预收5元邮费，待新卡完成首笔充值后便可以在充值页面公告栏处申请邮费全额原路返还哦。
      </p> -->
      <br />
      <mt-button
        v-if="isNeedPostage"
        type="primary"
        size="large"
        @click="payPostage()"
        >支付邮费</mt-button
      >
      <mt-button
        v-if="disabledFlag == false && isNeedPostage == false"
        type="primary"
        size="large"
        @click="applyChgCardHandler()"
        >申请换卡</mt-button
      >

      <!-- <mt-button
        style="margin-top: 5px"
        v-if="!isNeedPostage"
        type="primary"
        size="large"
        @click="toBackPostagePage()"
        >申请退还邮费</mt-button
      > -->
    </div>

     <div v-html="payUrl"></div>
            <div class="shareit" v-if="is_WeChat">
              <img class="arrow" src="@/assets/img/arrowhead.png"/>
              <div class="follow">支付宝支付请使用游览器进行支付,<br />请在菜单中选择游览器打开<br />如已完成支付，退出重新登录查询即可</div>
          </div>


  </div>
</template>
<script>
import { Dialog } from "vant";
import { Toast } from "vant";

import { wxRequest } from "@/api/user.js";
import myaddress from "@/utils/pca.json";
import areaListData from "@/utils/Area.js";

export default {
  name: "userChgCard",
  data() {
    return {
      is_WeChat:false,
      payUrl:'',


      payCode: localStorage.getItem("payCode"),
      recordLoginText: localStorage.getItem("recordLoginText"),
      leshuaPay: localStorage.getItem("leshuaPay"),
      userInfo: {
        oldIccid: "",
        takeNickname: "",
        takePhone: "",
        pcaAddress: "",
        takeAddress: "",
        disposeState: "",
        disposeRemark: "",
        changeCmccSim: 1,
        changeCmccSimName: "移动卡",
        equipment: "移动",
      },
      detailAddress: "",
      disabledFlag: false,
      slots: ["移动卡", "联通卡", "任意卡"],
      defaultIndex: 0,

      //卡类型
      popupVisible: false,

      addressVisible: false,
      areaList: areaListData,
      addressTmp: "",

      //是否需要支付邮费
      isNeedPostage: false,

      tips: "温馨提醒：就卡流量将会自动转到新卡上面。",
    };
  },
  methods: {
    applyChgCardHandler() {
      if (
        this.userInfo.takeNickname == "" ||
        this.userInfo.takePhone == "" ||
        this.userInfo.takeAddress == "" ||
        this.userInfo.pcaAddress == ""
      ) {
        Dialog.alert({ title: "提示", message: "请确保信息完整正确" });
        return;
      }
      
      var data = JSON.parse(JSON.stringify(this.userInfo));
      wxRequest("applyChangeSim/add", data, "post").then((res) => {
        if (res.data.code == 200) {
          Dialog.alert({ title: "提示", message: "申请成功！" }).then(() => {
           // this.refresh();
          });
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },

    hasAsterisk(str) {
      let s = str || "";
      if (s.indexOf("*") > -1) {
        return 1;
      }
      return 0;
    },

    //提示语判断
    judgeTips() {
      let fd = new FormData();
      fd.append(
        "iccid",
        this.$route.query.oldIccid
          ? this.$route.query.oldIccid
          : localStorage.getItem("iccid")
      );
      wxRequest("applyChangeSim/isChange", fd, "post").then((res) => {
        if (res.data.code == "200") {
          let cardTypeStr = "电信";
          if (res.data.data) {
            cardTypeStr =
              res.data.data.cardType == 0
                ? "移动"
                : res.data.data.cardType == 1
                ? "电信"
                : "联通";
          }

        }
      });
    },

    //判断是否需要支付邮费
    judgeIsNeedPostage() {
      let fd = new FormData();

      fd.append(
        "iccid",
        this.$route.query.oldIccid
          ? this.$route.query.oldIccid
          : localStorage.getItem("iccid")
      );
      wxRequest("applyChangeSim/isNeedPostage", fd, "post").then((res) => {
        this.isNeedPostage = res.data.code == 200;
      });
    },

    payPostage() {
      if (
        this.userInfo.takeNickname == "" ||
        this.userInfo.takePhone == "" ||
        this.userInfo.takeAddress == "" ||
        this.userInfo.pcaAddress == ""
      ) {
        Dialog.alert({ title: "提示", message: "请确保信息完整正确" });
        return;
      }

      var data = JSON.parse(JSON.stringify(this.userInfo));
      wxRequest("applyChangeSim/add", data, "post").then((res) => {
        if (res.data.code == 200) {
          let _this = this;
          let fd = new FormData();
          fd.append("iccid", this.userInfo.oldIccid);
          if (this.payCode == 502) {
            wxRequest("order/postage/add/hf", fd, "post").then((res) => {
              if (res.data.code == 200) {
                let datas = JSON.parse(res.data.data);
                if (datas.status === "succeeded") {
                  let payment = datas;
                  AdaPay.doPay(payment, (res) => {
                    Dialog.alert({
                      title: "提示",
                      message: res.result_message,
                    });
                  });
                }
              } else {
                Dialog.alert({ title: "提示", message: res.data.message });
              }
            });
          }else if (this.payCode == 503) {
            wxRequest("order/postage/add/jd", fd, "post").then((res) => {
              if (res.data.code == 200) {
                 window.location.href=res.data.data;
              } else {
                Dialog.alert({ title: "提示", message: res.data.message });
              }
            });
          }else  if (this.payCode == 508) {
            wxRequest("order/dhPkgOrder/add/yf", fd, "post").then((res) => {
              if (res.data.code == 200) {
                let param = res.data.data;
                WeixinJSBridge.invoke(
                  "getBrandWCPayRequest",
                  param,
                  function (res) {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                      _this.judgeIsNeedPostage();
                    }
                  }
                );
              } else {
                Dialog.alert({ title: "提示", message: res.data.message });
              }
            });
          }else  if (this.payCode == 507) {
            wxRequest("order/yyPkgOrder/add/yf", fd, "post").then((res) => {
              if (res.data.code == 200) {
                let param = res.data.data;
                window.location.href=param;
              } else {
                Dialog.alert({ title: "提示", message: res.data.message });
              }
            });
          }else  if (this.payCode == 566) {
            wxRequest("order/ebPkgOrder/add/yf", fd, "post").then((res) => {
              if (res.data.code == 200) {
                let param = res.data.data;
                WeixinJSBridge.invoke(
                  "getBrandWCPayRequest",
                  param,
                  function (res) {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                      _this.judgeIsNeedPostage();
                    }
                  }
                );
              } else {
                Dialog.alert({ title: "提示", message: res.data.message });
              }
            });
          }else  if (this.payCode == 588) {
            wxRequest("order/ali/postage/add", fd, "post").then((res) => {
              if (res.data.code == 200) {
                   var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                //进入引导页
                this.is_WeChat = true
                var timer = setInterval(()=>{
                  clearInterval(timer)
                  this.$router.push({path: '/user/userChgCard', query: {row: encodeURIComponent(JSON.stringify(res.data.data))}});
                },1000)
            } else {
              this.payUrl = res.data.data
              this.$nextTick(()=>{
                document.forms[0].submit()
              })
            }
              } else {
                Dialog.alert({ title: "提示", message: res.data.message });
              }
            });
          }
           else {
            wxRequest("order/postage/add", fd, "post").then((res) => {
              if (this.leshuaPay == 1) {
                window.location.href = res.data.data.jspay_url;
              } else {
                let param = res.data.data.param;
                WeixinJSBridge.invoke(
                  "getBrandWCPayRequest",
                  param,
                  function (res) {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                      _this.judgeIsNeedPostage();
                    }
                  }
                );
              }
            });
          }
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },

    showPopupVisible() {
      if (this.disabledFlag) {
        return;
      }
      this.popupVisible = true;
    },

    selectValue(value, index) {
       this.userInfo.changeCmccSimName = value
            if(value=='电信卡'){
                this.userInfo.changeCmccSim=1;
            }else if(value=='联通卡'){
                this.userInfo.changeCmccSim=3;
            }else if(value=='移动卡'){
                this.userInfo.changeCmccSim=2;
            }else{
                 this.userInfo.changeCmccSim=6;
            }
          //  this.userInfo.changeCmccSim = value == '电信卡' ? 1 : value == '移动卡' ? 2 : 6;
            this.popupVisible = false;
    },

    showAddressVisible() {
      if (this.disabledFlag) {
        return;
      }
      this.addressVisible = true;
    },

    cancelSelectAddress() {
      this.addressTmp = "";
      this.userInfo.pcaAddress = "";
      this.addressVisible = false;
    },

    selectAddress(values) {
      if (!values[0].code || values[0].code.length < 1) {
        Toast.fail("请选择地区");
        return;
      }

      if (!values[1].code || values[1].code.length < 1) {
        Toast.fail("请选择地区");
        return;
      }

      if (!values[2].code || values[2].code.length < 1) {
        Toast.fail("请选择地区");
        return;
      }

      if (
        values[0].code == "110000" ||
        values[0].code == "120000" ||
        values[0].code == "310000" ||
        values[0].code == "500000"
      ) {
        this.addressTmp = values[0].name + values[2].name;
      } else {
        this.addressTmp = values[0].name + values[1].name + values[2].name;
      }

      this.userInfo.pcaAddress = this.addressTmp;
      this.addressVisible = false;
    },

    refresh() {
      var query = this.$route.query;
      if (query.disposeState) {
        this.userInfo = query;
        if (
          this.userInfo.disposeState == 1 ||
          this.userInfo.disposeState == 3
        ) {
          this.disabledFlag = true;
          return;
        }
      } else {
        var data = {
          oldIccid: query.oldIccid,
        };
        wxRequest("applyChangeSim/info", data, "post").then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.oldIccid != null) {
              for (var key in this.userInfo) {
                this.userInfo[key] = res.data.data[key];
              }
              this.userInfo.changeCmccSim = query.changeCmccSim;
              switch (this.userInfo.disposeState) {
                case 1: //待审核
                case 3: //通过
                  this.disabledFlag = true;
                  break;
                case 5:
                  Dialog.alert({
                    title: "提示",
                    message: "您没有权限申请换卡！",
                  }).then(() => {
                    this.$router.push({
                      path: "/user/home",
                      query: {
                        iccid: this.$store.state.iccid,
                      },
                    });
                  });

                  break;
                default:
                  break;
              }
            }
            //换卡申请详情不存在
            else {
              this.userInfo.oldIccid = data.oldIccid;
              this.defaultIndex = query.changeCmccSim;
            }
          } else {
            Dialog.alert({ title: "提示", message: res.data.message }).then(
              () => {
                this.$router.push({
                  path: "/user/home",
                  query: {
                    iccid: this.$store.state.iccid,
                  },
                });
              }
            );
          }
        });
      }
    },

    toBackPostagePage() {
      this.$router.push({
        path: "/user/returnPostage",
        query: {
          oldIccid: this.recordLoginText,
        },
      });
    },
  },
  created() {
    this.is_WeChat = false
    if(this.$route.query.row){
      this.payUrl = JSON.parse(decodeURIComponent(this.$route.query.row))
      this.$nextTick(()=>{
        document.forms[0].submit()
      })
    }

    
    this.refresh();
    this.judgeIsNeedPostage();
    //提示语判断
    this.judgeTips();
  },
};
</script>
<style lang="less" scoped>
#userChgCard {
  em {
    display: block;
    background: #26a2ff;
    color: #fff;
    padding: 10px;
    line-height: 1.5em;
  }

  .btnOuter {
    margin: 20px 0 40px;
    padding: 0 5%;
  }

  .form-input {
    .tip {
      padding: 2px 10px;
    }
  }

  .tip {
    color: red;
    line-height: 16px;
    font-size: 12px;
  }
}
.shareit {
    -webkit-user-select: none;
    position: fixed;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    text-align: center;
    top: 0;
    left: 0;
    z-index: 999;
}
.shareit img {
    max-width: 100%;
}
.arrow {
    width: 100px;
    height: 150px;
    position: absolute;
    right: 5%;
    top: 1%;
}
.follow {
    margin-right: 6px;
    margin-left: 30px;
    width: 90%;
    // height: 100rpx;
    line-height: 30px;
    // text-align: left;
    text-decoration: none;
    font-size: 18px;
    color: white;
    float: left;
    margin-top: 180px;
}

</style>

<style>
#userChgCard .form-input .van-field__control {
  line-height: 24px;
}


</style>